import { PathsV1BranchSearchPostParametersQueryExtend } from "@/api-schema-enums";
import { UNLIMITED_PAGE_SIZE } from "../api/_defaults";
import { useBranchSearchQuery } from "../api/branch/use-branch-search.query";
import { useBrandSearchQuery } from "../api/brand/use-brand-search.query";
import { useCompanyGroupSearchQuery } from "../api/company-group/use-company-group-search.query";
import { useCompanySearchQuery } from "../api/company/use-company-search.query";
import { useDepartmentSearchQuery } from "../api/department/use-department-search.query";
import { useJobFunctionSearchQuery } from "../api/job-function/use-job-function-search.query";
import { useOccupationSearchQuery } from "../api/occupation/use-occupation-search.query";

export function useUserRuleAttributes() {
  const {
    data: companies,
    error: companiesError,
    isPending: companiesIsPending,
  } = useCompanySearchQuery({
    options: {
      parameters: {
        pageSize: UNLIMITED_PAGE_SIZE,
      },
    },
  });
  const {
    data: companyGroups,
    error: companyGroupsError,
    isPending: companyGroupsIsPending,
  } = useCompanyGroupSearchQuery({
    options: {
      parameters: {
        pageSize: UNLIMITED_PAGE_SIZE,
      },
    },
  });
  const {
    data: branches,
    error: branchesError,
    isPending: branchesIsPending,
  } = useBranchSearchQuery({
    options: {
      parameters: {
        pageSize: UNLIMITED_PAGE_SIZE,
        extend: [
          PathsV1BranchSearchPostParametersQueryExtend.Company,
          PathsV1BranchSearchPostParametersQueryExtend.Brands,
          PathsV1BranchSearchPostParametersQueryExtend.Address,
          PathsV1BranchSearchPostParametersQueryExtend.BranchIdentifiers,
        ],
      },
    },
  });
  const {
    data: departments,
    error: departmentsError,
    isPending: departmentsIsPending,
  } = useDepartmentSearchQuery({
    options: {
      parameters: {
        pageSize: UNLIMITED_PAGE_SIZE,
      },
    },
  });
  const {
    data: occupations,
    error: occupationsError,
    isPending: occupationsIsPending,
  } = useOccupationSearchQuery({
    options: {
      parameters: {
        pageSize: UNLIMITED_PAGE_SIZE,
      },
    },
  });
  const {
    data: brands,
    error: brandsError,
    isPending: brandsIsPending,
  } = useBrandSearchQuery({
    options: {
      parameters: {
        pageSize: UNLIMITED_PAGE_SIZE,
      },
    },
  });
  const {
    data: jobFunctions,
    error: jobFunctionsError,
    isPending: jobFunctionsIsPending,
  } = useJobFunctionSearchQuery({
    options: {
      parameters: {
        pageSize: UNLIMITED_PAGE_SIZE,
      },
    },
  });

  return {
    companies,
    companyGroups,
    branches,
    departments,
    occupations,
    brands,
    jobFunctions,
    isPending:
      brandsIsPending ||
      companiesIsPending ||
      companyGroupsIsPending ||
      branchesIsPending ||
      departmentsIsPending ||
      occupationsIsPending ||
      jobFunctionsIsPending,
    error:
      brandsError ||
      companiesError ||
      companyGroupsError ||
      branchesError ||
      departmentsError ||
      occupationsError ||
      jobFunctionsError,
  };
}
